import Badge from "@material-ui/core/Badge";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { URLS } from "@constants";
import bell from "@static/img/dashboard/bell.png";
import chat from "@static/img/dashboard/chat.png";
import chart from "@static/img/dashboard/chart.png";
import file from "@static/img/dashboard/file.png";
import plan from "@static/img/dashboard/plan.png";
import user from "@static/img/dashboard/user.png";
import card from "@static/img/icons/card.png";
import "./css/HomePage.scss";
import { useGetAlertCount } from "./hook/useGetAlertCount";
import { CurrentOrder } from "@features/Order/CurrentOrder";
import { fixUrlLanguage } from "@utils/changeLanguage";

interface IWelcomeMenuItem {
    badge?: number;
    externalUrl?: string;
    img: string;
    label: string;
    url?: string;
}

export const HomePage = () => {
    const { t } = useTranslation(["navigation", "glossary"]);
    const { count } = useGetAlertCount();
    const history = useHistory();

    const navigateTo = (url?: string, externalUrl?: string) => {
        externalUrl ? (window.location.href = externalUrl) : history.push(url ?? "");
    };

    const menuItemList: IWelcomeMenuItem[] = [
        {
            badge: count,
            img: bell,
            label: t("navigation:myAlerts"),
            url: fixUrlLanguage(URLS.ALERTS_PAGE_URL_EN),
        },
        {
            img: file,
            label: t("navigation:myBills"),
            url: fixUrlLanguage(URLS.BILLS_PAGE_URL_EN),
        },
        {
            img: chart,
            label: t("navigation:myUsage"),
            url: fixUrlLanguage(URLS.USAGE_PAGE_URL_EN),
        },
        {
            img: card,
            label: t("navigation:myPayments"),
            url: fixUrlLanguage(URLS.PAYMENTS_PAGE_URL_EN),
        },
        {
            img: plan,
            label: t("navigation:accountDetails"),
            url: fixUrlLanguage(URLS.ACCOUNT_DETAILS_PAGE_URL_EN),
        },
        {
            img: user,
            label: t("navigation:myProfile"),
            url: fixUrlLanguage(URLS.PROFILE_PAGE_URL_EN),
        },
        {
            url: fixUrlLanguage(URLS.SUBMIT_DOCUMENTS_URL_EN),
            img: chat,
            label: t("navigation:submitDocuments"),
        },
    ];

    const LabelTypography = (labelProps: { menuItem: IWelcomeMenuItem }) => {
        const label = (
            <Typography color="secondary" variant="subtitle2">
                {labelProps.menuItem.label}
            </Typography>
        );

        if (labelProps.menuItem.badge) {
            return (
                <Badge badgeContent={count} className="home-menu-content__badge" color="secondary">
                    {label}
                </Badge>
            );
        }

        return label;
    };

    return (
        <Fragment>
            <div className="home-banner">
                <Typography color="inherit" gutterBottom variant="h1">
                    {t("glossary:welcome")}
                </Typography>
            </div>
            <div className="container-boxed">
                <Card className="home-menu" elevation={2}>
                    <CardContent className="home-menu-content">
                        <List component="nav">
                            <Grid container spacing={2} wrap="wrap">
                                {menuItemList.map((menuItem) => (
                                    <Grid data-testid="menu-button" item key={menuItem.label} sm={6} xs={12}>
                                        <ListItem
                                            button
                                            className="home-menu-content__navigation"
                                            onClick={() => navigateTo(menuItem.url, menuItem.externalUrl)}
                                        >
                                            <ListItemIcon className="home-menu-content__icon">
                                                <img alt={menuItem.label} src={menuItem.img} />
                                            </ListItemIcon>
                                            <ListItemText primary={<LabelTypography menuItem={menuItem} />} />
                                            <KeyboardArrowRight />
                                        </ListItem>
                                        <Divider light />
                                    </Grid>
                                ))}
                            </Grid>
                        </List>
                    </CardContent>
                </Card>
                <div className="home-orders">
                    <CurrentOrder isHomePage />
                </div>
            </div>
        </Fragment>
    );
};
